
<modal :state="state" :index="index" @toggle-modal="emitHideModal" class="xxl">
  <div :slot="ModalStatus.Confirmation">
    <h3 class="modal-title">Configure</h3>

    <div class="row configure-sidebar-section">
      <div class="col-3">
        <scroll-area class="sidebar-edit">
          <draggable v-model="bookmarkMenu.sortedBookmarkFolders" v-bind="VueDraggableDefinition.getOptions()" @change="persistBookmarkFolderMove">
            <div v-for="folder in bookmarkMenu.sortedBookmarkFolders" :key="folder.id" class="align-left">
              <configure-bookmark-folder
                v-if="!isDashboardFolder(folder)"
                :folder="folder"
              />
              <hr>
            </div>
          </draggable>
        </scroll-area>

        <button @click="createFolderClicked" class="btn grey-to-blue full-sz">
          Create Menu Folder
        </button>
      </div>

      <div class="col-9" >
        <add-folder
          v-if="interfaceMode === ConfigureSidebarModes.newFolder"
        />
        <edit-folder
          v-if="(interfaceMode === ConfigureSidebarModes.showFolder) || (interfaceMode === ConfigureSidebarModes.editFolder)"
          :folder="selectedFolder"
        />
        <bookmark-link-create-show-edit
          v-if="showBookmarkLinkForm"
          :folder="selectedFolder"
          :existing-link="selectedLink"
        />
      </div>
    </div>
  </div>
</modal>
